import styled from 'react-emotion';

const Page = styled('div')`
  display: flex;
  height: 100%;
  width: 100%;
`;

export default Page;



// WEBPACK FOOTER //
// ./src/components/page.js